import { Player } from "service/player/type";
import { CharacterBox } from "types/Player/type";

export const isUserAdmin = (player?: Player) =>
  player?.roles?.includes("ROLE_ADMIN") ?? false;
export const isUserOrganisator = (player?: Player) =>
  player?.roles?.includes("ROLE_ORGA") ?? false;

export const formatTimer = (time: number) => {
  let res = "";
  const minutes = Math.floor(time / 60);
  if (minutes > 0) res += minutes + ":";
  const seconds = time % 60;
  if (seconds < 10) res += "0" + seconds;
  else res += seconds;
  return res;
};

export const formatDate = (date: number) => {
  const d = new Date(date);
  const formatTwoDigits = (n: number) => (n < 10 ? `0${n}` : n);
  return `${formatTwoDigits(d.getDate())}/${formatTwoDigits(
    d.getMonth() + 1,
  )}/${d.getFullYear()}, ${formatTwoDigits(d.getHours())}:${formatTwoDigits(
    d.getMinutes(),
  )}`;
};

export const applyBoxPreferences = (
  box: CharacterBox[],
  preferences?: CharacterBox[],
) => {
  if (preferences === undefined) return box;
  const map = preferences.map((c) => c.name);
  return box.filter((c) => !map.includes(c.name));
};

/*
  Props d'un lien de téléchargement de box au format JSON (ré-importable tel quel). Avec une
  feuille, la box est filtrée selon les préférences du joueur et le nom de la feuille est
  ajouté au nom du fichier.
*/
export const boxDownloadProps = (
  pseudo: string | undefined,
  box: CharacterBox[],
  sheetName?: string,
) => ({
  href: `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(box),
  )}`,
  download: `${[pseudo ?? "box", sheetName].filter(Boolean).join(" - ")}.json`,
});

export const areCharacterBoxesEqual = (
  first?: CharacterBox[],
  second?: CharacterBox[],
) => {
  if (first === second) return true;
  if (!first || !second || first.length !== second.length) return false;

  return first.every((character) => {
    const match = second.find((other) => other.name === character.name);
    return (
      match !== undefined &&
      match.constellation === character.constellation &&
      match.lvl === character.lvl
    );
  });
};
